import React from "react";

export default function InsuranceProcess({
  title,
  subtitle,
  imageL,
  imageD,
  steps,
}) {
  return (
    <section className="  bg-sidom-light dark:bg-sidom-blue overflow-hidden">
      <div className="container mx-auto ">
        <h2 className="text-3xl font-bold mb- text-left w-full  ">
          {title} <span className="text-sidom-orange">{subtitle}</span>
        </h2>
        <div className="flex flex-col lg:flex-row gap-8 items-center ">
          <div className="w-[60%]">
            <img
              src={imageL}
              className="block dark:hidden w-full h-auto"
              alt="Imagen modo oscuro"
            />

            <img
              src={imageD}
              className="  hidden dark:block w-full h-auto"
              alt="Imagen modo claro"
            />
          </div>
          <div className="w-[40%] ">
            <ol className="list-decimal pl-5 space-y-4 text-sidom-dark dark:text-sidom-light">
              {steps.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
